import React, {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Sidenav, Dropdown, Drawer, Icon, Nav } from 'rsuite';
import MenuOutlinedIcon from '@material-ui/icons/MenuOutlined';
import IconButton from '@material-ui/core/IconButton';
import { useHistory } from "react-router-dom";
import * as actionsAuth from '../../app/actions/auth/auth';
import * as actionsPolicy from '../../app/actions/policy'


const TopBtnNav = ({toggleContactFormBox}) => {
    const history = useHistory();
    const dispatch = useDispatch()
    const pathname = history?.location?.pathname;

    const auth = useSelector(state=>state.auth);
    const {loginToken} = auth || {};

    const [activeKey, setActiveKey] = useState('1');

    const [openDrawer, setOpenDrawer] = useState(false);

    useEffect(()=>{
        switch(pathname) {
            case '/app':
                return  setActiveKey('1');
            case '/app/my-policies':
                return  setActiveKey('1-1');
            case '/app/profile':
                return  setActiveKey('2-1');
            case '/app/sign-up':
                return setActiveKey('2-2');
            case '/app/new-policy-liability':
                return setActiveKey('3-1');
            case '/app/pay-installment/':
                return setActiveKey('3-2');
            case '/app/add-policy':
                return setActiveKey('3-3');
            default:
                return 'Unknown stepIndex';
        }
    }, [pathname]);
 
    const goToPage = async (eventKey) => {
        setActiveKey(eventKey === '2-3' ? '2-1' : eventKey);
        setOpenDrawer(false);
        
        switch(eventKey) {
            case '1':
                await dispatch(actionsPolicy.clearNewLiability());
                return history.push('/app/');
            case '1-1':
                return history.push('/app/my-policies');
            case '2-1':
                return history.push('/app/profile');
            case '2-2':
                return history.push('/app/sign-up');
            case '2-3':
                return dispatch(actionsAuth.logout());
            case '3-1':
                return history.push('/app/new-policy-liability');
            case '3-2':
                return history.push('/app/pay-installment/');
            case '3-3':
                return history.push('/app/add-policy');
            case '5':
                return toggleContactFormBox();
            case 'vinete':
                return <></>;
            default:
                return 'Unknown stepIndex';
        }
    }

    const openDrawerHandle = (event) => {
        event.stopPropagation();
        setOpenDrawer(true)
    }

    return (
      <div className="">
        
        <IconButton color="primary" onClick={openDrawerHandle} aria-label="menu" component="span">
          <MenuOutlinedIcon className="top-menu-btn"/>
        </IconButton>

        <Drawer placement={'top'} show={openDrawer} onHide={() => setOpenDrawer(false)} >
            <Drawer.Header>
                <Drawer.Title></Drawer.Title>
            </Drawer.Header>
            <Drawer.Body>
                <Sidenav defaultOpenKeys={[3,4,5]} activeKey={activeKey} 
                    style={{ backgroundColor: 'white', fontSize:"14px"}}
                    //appearance="inverse"
                    >    
                <Sidenav.Body>
                    <Nav>
                        <Nav.Item eventKey="1" icon={<Icon icon="dashboard" />} onSelect={goToPage}>
                            Начало
                        </Nav.Item>
                        <Nav.Item eventKey="1-1" icon={<Icon icon="tag-area" />} onSelect={goToPage} disabled={!loginToken}>
                            Полици
                        </Nav.Item>
                        <Dropdown eventKey="2" title="Профил" icon={<Icon icon="user-circle" />}>
                            <Dropdown.Item eventKey="2-1" onSelect={goToPage}>Влез в профил</Dropdown.Item>
                            {loginToken 
                                ? <Dropdown.Item eventKey="2-3" onSelect={goToPage}>Изход</Dropdown.Item>
                                : <Dropdown.Item eventKey="2-2" onSelect={goToPage}>Създай профил</Dropdown.Item>
                                }
                        </Dropdown>
                        <Dropdown eventKey="3" title="Гражданска отгворност" icon={<Icon icon="car" />}>
                            <Dropdown.Item eventKey="3-1" onSelect={goToPage}>Нова полица</Dropdown.Item>
                            <Dropdown.Item eventKey="3-2" onSelect={goToPage}>Плати вноска</Dropdown.Item>
                            <Dropdown.Item eventKey="3-3" onSelect={goToPage}>Добави полица</Dropdown.Item>
                        </Dropdown>
                        <Dropdown
                            eventKey="4"
                            title="Очаквайте скоро"
                            icon={<Icon icon="explore" />}
                        >
                            <Dropdown.Item eventKey="4-1" onSelect={goToPage}>Винетка</Dropdown.Item>
                            <Dropdown.Item eventKey="4-2" onSelect={goToPage}>Имуществена застраховка</Dropdown.Item>
                            <Dropdown.Item eventKey="4-3" onSelect={goToPage}>Здравна застраховка</Dropdown.Item>
                            <Dropdown.Item eventKey="4-4" onSelect={goToPage}>Помощ при пътуване</Dropdown.Item>
                        </Dropdown>
                        <Nav.Item eventKey="5" icon={<Icon icon="envelope-o" />} onSelect={goToPage} >
                            Пиши ни
                        </Nav.Item>
                    </Nav>
                </Sidenav.Body>
            </Sidenav>
            </Drawer.Body>
        </Drawer>

       </div> 
    )
}

export default TopBtnNav;